// extracted by mini-css-extract-plugin
export default {"mainContainer":"education_mainContainer__04sXy","container":"education_container__G++7S","card":"education_card__r-Kaz","icon":"education_icon__OW8+G","dark":"education_dark__oPV55"};